<div class="card">
  <header class="card-header">
    <p class="card-header-title is-size-4 has-background-white-ter">{{ 'claimMetadata.title' | localize }}&nbsp;-&nbsp;
      <span class="is-6">{{ 'menu.createClaim.forCondominiumUnit.label' | localize }}</span></p>
  </header>
  <div class="card-content">
    <article class="content">
      <span class="is-size-6 pl-3">{{ 'claimMetadata.instruction' | localize }}</span>
    </article>

    <div class="container">
      <form [formGroup]="metadataForm" class="metadata-form">

        <!-- Row 1: Adjuster ID & Adjuster Company -->
        <div class="columns is-gapless-mobile">
          <div class="column is-6">
            <mat-form-field appearance="outline" class="field-spacing">
              <mat-label>{{ 'claimMetadata.adjusterId.label' | localize }}</mat-label>
              <input matInput formControlName="adjusterID" placeholder="{{ 'claimMetadata.adjusterId.placeholder' | localize }}" readonly>
            </mat-form-field>
          </div>
          <div class="column is-6">
            <mat-form-field appearance="outline" class="field-spacing">
              <mat-label>{{ 'claimMetadata.adjusterCompany.label' | localize }}</mat-label>
              <input matInput formControlName="adjusterCompany" placeholder="{{ 'claimMetadata.adjusterCompany.placeholder' | localize }}" readonly>
            </mat-form-field>
          </div>
        </div>

        <!-- Row 2: Insurance Claim Reference & Loss Adjuster Claim Reference -->
        <div class="columns is-gapless-mobile">
          <div class="column is-6">
            <mat-form-field appearance="outline" class="field-spacing">
              <mat-label>{{ 'claimMetadata.insuranceClaimRef.label' | localize }}</mat-label>
              <input matInput formControlName="insuranceClaimReference"
                     placeholder="{{ 'claimMetadata.insuranceClaimRef.placeholder' | localize }}" readonly>
            </mat-form-field>
          </div>
          <div class="column is-6">
            <mat-form-field appearance="outline" class="field-spacing">
              <mat-label>{{ 'claimMetadata.lossAdjusterRef.label' | localize }}</mat-label>
              <input matInput formControlName="lossAdjusterClaimReference"
                     placeholder="{{ 'claimMetadata.lossAdjusterRef.placeholder' | localize }}" readonly>
            </mat-form-field>
          </div>
        </div>

        <!-- Row 3: Condominium Name & Unit Owner Name -->
        <div class="columns is-gapless-mobile">

          <div class="column is-6">
            <mat-form-field appearance="outline" class="field-spacing">
              <mat-label>{{ 'claimMetadata.unitOwnerName.label' | localize }}</mat-label>
              <input matInput formControlName="unitOwnerName" placeholder="{{ 'claimMetadata.unitOwnerName.placeholder' | localize }}">
            </mat-form-field>
          </div>
          <div class="column is-6">
            <mat-form-field appearance="outline" class="field-spacing">
              <mat-label>{{ 'claimMetadata.unitNumber.label' | localize }}</mat-label>
              <input matInput formControlName="unitNumber" placeholder="{{ 'claimMetadata.unitNumber.placeholder' | localize }}">
            </mat-form-field>
          </div>
        </div>

        <!-- Row 4: Address & Unit Number -->
        <div class="columns is-gapless-mobile">
          <div class="column is-6">
            <mat-form-field appearance="outline" class="field-spacing">
              <mat-label>{{ 'claimMetadata.condominiumName.label' | localize }}</mat-label>
              <input type="text"
                     class="field-spacing"
                     placeholder="{{ 'claimMetadata.condominiumName.placeholder' | localize }}"
                     aria-label="{{ 'claimMetadata.condominiumName.label' | localize }}"
                     matInput
                     formControlName="condominiumName"
                     [matAutocomplete]="auto">
              <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
                @for (option of condominiumFilteredOptions; track option) {
                  <mat-option [value]="option">{{ option }}</mat-option>
                }
              </mat-autocomplete>
            </mat-form-field>
          </div>
          <div class="column is-6">
            <mat-form-field appearance="outline" class="field-spacing">
              <mat-label>{{ 'claimMetadata.address.label' | localize }}</mat-label>
              <textarea matInput formControlName="address" rows="5" placeholder="{{ 'claimMetadata.address.placeholder' | localize }}"></textarea>
            </mat-form-field>
          </div>
        </div>
      </form>
    </div>
    @if (error && !isSubmitting) {
      <div class="message is-danger">
        <div class="message-body">
          {{ error }}
        </div>
      </div>
    }
  </div>
  <footer class="card-footer">
    <div class="card-footer-item">
      @if (isSubmitting) {
        <mat-spinner></mat-spinner>
      } @else {
        <button [disabled]="isSubmitting" class="button is-dark" (click)="onInitiateClaim()">{{ 'claimMetadata.initiateClaim' | localize }}</button>
      }
    </div>
  </footer>
</div>
